

// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://osyvijwnivquvqvmxtjh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9zeXZpanduaXZxdXZxdm14dGpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA3NTU4MDgsImV4cCI6MjA1NjMzMTgwOH0.NAP5eJFh-SR_iBh2NNU6vSAbyEHsWzeHDJbQR-0WWVs";

// Service role key will be accessed only when needed server-side

// Lazy-load the Supabase client to improve initial page load times
// This creates the client only when it's actually needed
let supabaseInstance: ReturnType<typeof createClient<Database>> | null = null;
let supabaseAdminInstance: ReturnType<typeof createClient<Database>> | null = null;

export const getSupabase = () => {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
  }
  return supabaseInstance;
};

export const getSupabaseAdmin = () => {
  if (typeof window !== 'undefined') {
    console.warn('Warning: Attempted to use service role client in browser context');
    // Return regular client as fallback
    return getSupabase();
  }
  
  // Get service role key only when needed server-side
  const serviceRoleKey = import.meta.env?.SUPABASE_SERVICE_ROLE_KEY || '';
  
  if (!supabaseAdminInstance && serviceRoleKey) {
    supabaseAdminInstance = createClient<Database>(
      SUPABASE_URL, 
      serviceRoleKey,
      {
        auth: {
          autoRefreshToken: false,
          persistSession: false
        }
      }
    );
  }
  
  return supabaseAdminInstance || getSupabase();
};

// Backwards compatibility for existing imports
// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";
export const supabase = getSupabase();
